module.exports = __webpack_public_path__ + "img/6.356cbd98.jpg";